// packages/shared-components/src/config/color.ts

/**
 * 颜色配置常量
 * 预设颜色数组（供 Palette 和 ColorPicker 共享）
 */

/**
 * Palette 调色板的默认预设颜色（10个）
 */
export const DEFAULT_PALETTE_COLORS = [
  "#FF0000", // 红色
  "#FFA500", // 橙色
  "#FFFF00", // 黄色
  "#00FF00", // 绿色
  "#00FFFF", // 青色
  "#0000FF", // 蓝色
  "#800080", // 紫色
  "#CDDC39", // 青柠色
  "#8BC34A", // 浅绿色
  "#00BCD4", // 青蓝色
  "#AD9B9B", // 青蓝色
  "#681A1A", // 青蓝色
];

/**
 * ColorPicker 颜色选择器的基础预设颜色（8个）
 */
export const DEFAULT_PICKER_COLORS = [
  "#FF5722", // 红色
  "#FF9800", // 橙色
  "#FFC107", // 黄色
  "#4CAF50", // 绿色
  "#00BCD4", // 青色
  "#2196F3", // 蓝色
  "#9C27B0", // 紫色
  "#607D8B", // 灰蓝色
];

/**
 * ColorPicker 颜色选择面板的扩展预设颜色（80个）
 */
export const EXTENDED_PICKER_COLORS = [
  // 第一行：红色系
  "#FFEBEE",
  "#FFCDD2",
  "#EF9A9A",
  "#E57373",
  "#EF5350",
  "#F44336",
  "#E53935",
  "#D32F2F",
  "#C62828",
  "#B71C1C",

  // 第二行：橙色系
  "#FFF3E0",
  "#FFE0B2",
  "#FFCC80",
  "#FFB74D",
  "#FFA726",
  "#FF9800",
  "#FB8C00",
  "#F57C00",
  "#EF6C00",
  "#E65100",

  // 第三行：黄色系
  "#FFFDE7",
  "#FFF9C4",
  "#FFF59D",
  "#FFF176",
  "#FFEE58",
  "#FFEB3B",
  "#FDD835",
  "#FBC02D",
  "#F9A825",
  "#F57F17",

  // 第四行：绿色系
  "#E8F5E9",
  "#C8E6C9",
  "#A5D6A7",
  "#81C784",
  "#66BB6A",
  "#4CAF50",
  "#43A047",
  "#388E3C",
  "#2E7D32",
  "#1B5E20",

  // 第五行：青色系
  "#E0F7FA",
  "#B2EBF2",
  "#80DEEA",
  "#4DD0E1",
  "#26C6DA",
  "#00BCD4",
  "#00ACC1",
  "#0097A7",
  "#00838F",
  "#006064",

  // 第六行：蓝色系
  "#E3F2FD",
  "#BBDEFB",
  "#90CAF9",
  "#64B5F6",
  "#42A5F5",
  "#2196F3",
  "#1E88E5",
  "#1976D2",
  "#1565C0",
  "#0D47A1",

  // 第七行：紫色系
  "#F3E5F5",
  "#E1BEE7",
  "#CE93D8",
  "#BA68C8",
  "#AB47BC",
  "#9C27B0",
  "#8E24AA",
  "#7B1FA2",
  "#6A1B9A",
  "#4A148C",

  // 第八行：灰色系
  "#FAFAFA",
  "#F5F5F5",
  "#EEEEEE",
  "#E0E0E0",
  "#BDBDBD",
  "#9E9E9E",
  "#757575",
  "#616161",
  "#424242",
  "#212121",
];
